import { getCurrentScope as x, onScopeDispose as F, unref as I, toRef as O, readonly as P, customRef as R, ref as h, isRef as S, watch as g } from "vue";
function y(e) {
  return x() ? (F(e), !0) : !1;
}
function p(e) {
  return typeof e == "function" ? e() : I(e);
}
const v = typeof window < "u" && typeof document < "u", C = Object.prototype.toString, k = (e) => C.call(e) === "[object Object]", E = () => +Date.now(), f = () => {
}, L = /* @__PURE__ */ A();
function A() {
  var e;
  return v && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && /* @__PURE__ */ /iP(ad|hone|od)/.test(window.navigator.userAgent);
}
function D(e, t) {
  function r(...o) {
    return new Promise((i, n) => {
      Promise.resolve(e(() => t.apply(this, o), { fn: t, thisArg: this, args: o })).then(i).catch(n);
    });
  }
  return r;
}
function N(e, t = {}) {
  let r, o, i = f;
  const n = (u) => {
    clearTimeout(u), i(), i = f;
  };
  return (u) => {
    const c = p(e), l = p(t.maxWait);
    return r && n(r), c <= 0 || l !== void 0 && l <= 0 ? (o && (n(o), o = null), Promise.resolve(u())) : new Promise((a, d) => {
      i = t.rejectOnCancel ? d : a, l && !o && (o = setTimeout(() => {
        r && n(r), o = null, a(u());
      }, l)), r = setTimeout(() => {
        o && n(o), o = null, a(u());
      }, c);
    });
  };
}
function W(e, t = !0, r = !0, o = !1) {
  let i = 0, n, s = !0, u = f, c;
  const l = () => {
    n && (clearTimeout(n), n = void 0, u(), u = f);
  };
  return (d) => {
    const m = p(e), T = Date.now() - i, w = () => c = d();
    return l(), m <= 0 ? (i = Date.now(), w()) : (T > m && (r || !s) ? (i = Date.now(), w()) : t && (c = new Promise((b, j) => {
      u = o ? j : b, n = setTimeout(() => {
        i = Date.now(), s = !0, b(w()), l();
      }, Math.max(0, m - T));
    })), !r && !n && (n = setTimeout(() => s = !0, m)), s = !1, c);
  };
}
function M(e, t = !1, r = "Timeout") {
  return new Promise((o, i) => {
    setTimeout(t ? () => i(r) : o, e);
  });
}
function U(e, t) {
  var r;
  if (typeof e == "number")
    return e + t;
  const o = ((r = e.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : r[0]) || "", i = e.slice(o.length), n = Number.parseFloat(o) + t;
  return Number.isNaN(n) ? e : n + i;
}
function $(...e) {
  if (e.length !== 1)
    return O(...e);
  const t = e[0];
  return typeof t == "function" ? P(R(() => ({ get: t, set: f }))) : h(t);
}
function q(e, t = 200, r = {}) {
  return D(
    N(t, r),
    e
  );
}
function z(e, t = 200, r = !1, o = !0, i = !1) {
  return D(
    W(t, r, o, i),
    e
  );
}
function V(e, t = 1e3, r = {}) {
  const {
    immediate: o = !0,
    immediateCallback: i = !1
  } = r;
  let n = null;
  const s = h(!1);
  function u() {
    n && (clearInterval(n), n = null);
  }
  function c() {
    s.value = !1, u();
  }
  function l() {
    const a = p(t);
    a <= 0 || (s.value = !0, i && e(), u(), n = setInterval(e, a));
  }
  if (o && v && l(), S(t) || typeof t == "function") {
    const a = g(t, () => {
      s.value && v && l();
    });
    y(a);
  }
  return y(c), {
    isActive: s,
    pause: c,
    resume: l
  };
}
function B(e = 1e3, t = {}) {
  const {
    controls: r = !1,
    immediate: o = !0,
    callback: i
  } = t, n = h(0), s = () => n.value += 1, u = () => {
    n.value = 0;
  }, c = V(
    i ? () => {
      s(), i(n.value);
    } : s,
    e,
    { immediate: o }
  );
  return r ? {
    counter: n,
    reset: u,
    ...c
  } : n;
}
export {
  D as createFilterWrapper,
  N as debounceFilter,
  U as increaseWithUnit,
  v as isClient,
  L as isIOS,
  k as isObject,
  f as noop,
  M as promiseTimeout,
  W as throttleFilter,
  E as timestamp,
  $ as toRef,
  p as toValue,
  y as tryOnScopeDispose,
  q as useDebounceFn,
  B as useInterval,
  V as useIntervalFn,
  z as useThrottleFn
};
